import * as Mod1 from "./discourse/components/doc-category-settings-form";
import * as Mod2 from "./discourse/components/doc-category-settings";
import * as Mod3 from "./discourse/components/doc-simple-mode-toggle";
import * as Mod4 from "./discourse/components/doc-updated-header-cell";
import * as Mod5 from "./discourse/docs-legacy-compatibility-route-map";
import * as Mod6 from "./discourse/initializers/doc-categories";
import * as Mod7 from "./discourse/lib/doc-category-sidebar-panel";
import * as Mod8 from "./discourse/lib/simple-mode";
import * as Mod9 from "./discourse/routes/doc-legacy-docs";
import * as Mod10 from "./discourse/routes/doc-legacy-kb-xplr";
import * as Mod11 from "./discourse/services/doc-category-sidebar";
const compatModules = {
  "discourse/components/doc-category-settings-form": Mod1,
  "discourse/components/doc-category-settings": Mod2,
  "discourse/components/doc-simple-mode-toggle": Mod3,
  "discourse/components/doc-updated-header-cell": Mod4,
  "discourse/docs-legacy-compatibility-route-map": Mod5,
  "discourse/initializers/doc-categories": Mod6,
  "discourse/lib/doc-category-sidebar-panel": Mod7,
  "discourse/lib/simple-mode": Mod8,
  "discourse/routes/doc-legacy-docs": Mod9,
  "discourse/routes/doc-legacy-kb-xplr": Mod10,
  "discourse/services/doc-category-sidebar": Mod11,
};
export default compatModules;
